module.exports = __webpack_public_path__ + "img/37.a0734b70.jpg";